import React from 'react';
import noop from '../utils/noop';
import { useDeviationMatureFilter } from '../utils/hooks/useDeviationMatureFilter';
export const MatureDeviationContext = /*#__PURE__*/ React.createContext({
    showBlocked: false,
    displayReason: undefined,
    overrideMatureFilter: noop
});
MatureDeviationContext.displayName = 'MatureDeviationContext';
export const MatureDeviationContextProvider = ({ children , deviation  })=>{
    const matureFilter = useDeviationMatureFilter(deviation);
    return /*#__PURE__*/ React.createElement(MatureDeviationContext.Provider, {
        value: matureFilter
    }, children);
};
MatureDeviationContextProvider.displayName = 'MatureDeviationContextProvider';
